/**
 * @generated SignedSource<<68b45b7fe9e3300cf48b6008c2e14cfa>>
 * @relayHash 598f333159c7c59d6997e4c6052006c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dad50531310f826cd88efd518c15a90d9399125a1c5c323b511cf3f494e678f4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraConfigStateConfigurationStatus = "CONFIGURED" | "NOT_CONFIGURED" | "NOT_INSTALLED" | "NOT_SET" | "PARTIALLY_CONFIGURED" | "PROVIDER_ACTION_CONFIGURED" | "PROVIDER_ACTION_NOT_CONFIGURED" | "%future added value";
export type CodeSectionQuery$variables = {
  cloudId: string;
  siteAri: string;
};
export type CodeSectionQuery$data = {
  readonly codeInJira: {
    readonly userConfiguration: {
      readonly ownedBitbucketWorkspaces: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined>;
    };
  };
  readonly devOps: {
    readonly providers: {
      readonly devInfoProviders: ReadonlyArray<{
        readonly configState: {
          readonly config: {
            readonly nodes: ReadonlyArray<{
              readonly appId: string;
              readonly status: JiraConfigStateConfigurationStatus | null | undefined;
            }> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly devOps: {
      readonly configState: {
        readonly config: {
          readonly nodes: ReadonlyArray<{
            readonly appId: string;
            readonly status: JiraConfigStateConfigurationStatus | null | undefined;
          }> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CodeSectionQuery = {
  response: CodeSectionQuery$data;
  variables: CodeSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "siteAri"
  },
  {
    "kind": "Literal",
    "name": "providerTypes",
    "value": [
      "DEV_INFO"
    ]
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "concreteType": "JiraConfigStateConnection",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraConfigState",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appId"
        },
        {
          "kind": "ScalarField",
          "name": "status"
        }
      ]
    }
  ]
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Literal",
    "name": "appId",
    "value": "bitbucket"
  },
  (v4/*: any*/)
],
v9 = {
  "concreteType": "CodeInJiraBitbucketWorkspace",
  "kind": "LinkedField",
  "name": "ownedBitbucketWorkspaces",
  "plural": true,
  "selections": [
    (v3/*: any*/)
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v6/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CodeSectionQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDevInfoProvider",
                "kind": "LinkedField",
                "name": "devInfoProviders",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraAppConfigState",
                    "kind": "LinkedField",
                    "name": "configState",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v5/*: any*/),
          "concreteType": "CodeInJira",
          "kind": "LinkedField",
          "name": "codeInJira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "CodeInJiraUserConfiguration",
                "kind": "LinkedField",
                "name": "userConfiguration",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v9/*: any*/),
                    "action": "THROW",
                    "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                  }
                ]
              },
              "action": "THROW",
              "path": "codeInJira.userConfiguration"
            }
          ]
        },
        "action": "THROW",
        "path": "codeInJira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CodeSectionQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDevInfoProvider",
                "kind": "LinkedField",
                "name": "devInfoProviders",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraAppConfigState",
                    "kind": "LinkedField",
                    "name": "configState",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": (v11/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dad50531310f826cd88efd518c15a90d9399125a1c5c323b511cf3f494e678f4",
    "metadata": {},
    "name": "CodeSectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "484924ea25d95f47fc065c4f7150eced";

export default node;
